module.exports = __webpack_public_path__ + "img/Rear door.f4e0164b.jpg";